import React from "react";

import {DealPage} from "../DealPage/DealPage";
import {DealContextProvider} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {BaseModal} from "../../components/BaseModal";



export const DealModal = ( { id, isOpen, setIsOpen, ...props } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const style = {
        position: 'absolute',
        top: isTabletOrMobile ? '56%' : '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        p: 4,
        height: '100vh',
        overflow: 'scroll'
    };

    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            style={style}
        >
            <DealContextProvider id={id} {...props}>
                <DealPage
                    isModal={true}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    {...props}
                />
            </DealContextProvider>
        </BaseModal>
    )
}